import { UITab, UIMenuItem } from '@constants';
import { useCheckScreenWithCallback } from '@hooks';
import React, { memo, useCallback, useState } from 'react';
import trans from 'translation';
import { KContainer, KTab } from 'uikit';

import AROverdue from './AROverdue';
// import ARPayments from './ARPayments';

const Report = () => {
  const cb = useCallback(() => {
    let _tabs = [
      {
        code: UITab.ARPayments,
        label: trans('ar_payments')
      },
      {
        code: UITab.AROverdue,
        label: trans('ar_overdue')
      },
      {
        code: UITab.APPayments,
        label: trans('ap_payments')
      },
      {
        code: UITab.APOverdue,
        label: trans('ap_overdue')
      }
    ];

    return _tabs;
  }, []);

  const [tabIndex, setTabIndex] = useState(0);

  const tabs = useCheckScreenWithCallback(cb, UIMenuItem.Accounting);

  return (
    <KContainer.Card
      height={1000}
      marginT={0}
      dp="flex"
      overflow="auto"
      alignItems="stretch"
      flexG={1}
    >
      <KContainer.View>
        <KTab.White
          marginB="0.5rem"
          marginT={0}
          spacing="0rem"
          typo="TextNmMedium"
          //@ts-ignore
          marginH={-16}
          height={50}
          tabs={tabs}
          onChangeTab={setTabIndex}
        />
      </KContainer.View>
      <KContainer.View alignItems="stretch" flexG={1} dp="flex">
        {tabs[tabIndex]?.code === UITab.ARPayments && (
          <AROverdue tabName={trans('ar_overdue')} />
        )}
        {tabs[tabIndex]?.code === UITab.AROverdue && (
          <AROverdue tabName={trans('ar_overdue')} />
        )}
        {tabs[tabIndex]?.code === UITab.APPayments && (
          <AROverdue tabName={trans('ar_overdue')} />
        )}
        {tabs[tabIndex]?.code === UITab.APOverdue && (
          <AROverdue tabName={trans('ar_overdue')} />
        )}
      </KContainer.View>
      {/* <KTab.Panel
        value={tabIndex}
        index={tabs.findIndex(i => i.code === UITab.ARPayment)}
      ></KTab.Panel>
      <KTab.Panel
        value={tabIndex}
        index={tabs.findIndex(i => i.code === UITab.AROverdue)}
      >
        <AROverdue />
      </KTab.Panel>
      <KTab.Panel
        value={tabIndex}
        index={tabs.findIndex(i => i.code === UITab.APPayment)}
      ></KTab.Panel>
      <KTab.Panel
        value={tabIndex}
        index={tabs.findIndex(i => i.code === UITab.APOverdue)}
      ></KTab.Panel> */}
    </KContainer.Card>
  );
};

export default memo(Report);
